import { render, staticRenderFns } from "./ListPlaceholderItem.vue?vue&type=template&id=b5145fba&scoped=true&"
import script from "./ListPlaceholderItem.vue?vue&type=script&lang=ts&"
export * from "./ListPlaceholderItem.vue?vue&type=script&lang=ts&"
import style0 from "./ListPlaceholderItem.vue?vue&type=style&index=0&id=b5145fba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5145fba",
  null
  
)

export default component.exports